import styled from 'styled-components';

export const CardWrapper = styled.div`
    position: relative;
`;

export const LoadingOverlay = styled.div`
    position: absolute;
    inset: 0;
    background-color: white;
    opacity: 0.7;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
`;
